var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.75C10.5 8.51125 5.5 13.25 5.5 13.25C5.5 13.25 0.5 8.51125 0.5 5.75C0.5 4.42392 1.02678 3.15215 1.96447 2.21447C2.90215 1.27678 4.17392 0.75 5.5 0.75C6.82608 0.75 8.09785 1.27678 9.03553 2.21447C9.97322 3.15215 10.5 4.42392 10.5 5.75Z",
    fill: "#234F68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.24994C5.69891 6.24994 5.88968 6.17092 6.03033 6.03027C6.17098 5.88962 6.25 5.69885 6.25 5.49994C6.25 5.30103 6.17098 5.11026 6.03033 4.96961C5.88968 4.82896 5.69891 4.74994 5.5 4.74994C5.30109 4.74994 5.11032 4.82896 4.96967 4.96961C4.82902 5.11026 4.75 5.30103 4.75 5.49994C4.75 5.69885 4.82902 5.88962 4.96967 6.03027C5.11032 6.17092 5.30109 6.24994 5.5 6.24994Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.9da0b9ce96d51d24cac26b98872063a3.svg";
export { ForwardRef as ReactComponent };